import UiLink from '@/components/UiLink.vue'
import UiCheckbox from '@/components/UiCheckbox.vue'
import getValue from '@/components/table/helpers/getValue'
import DateTime from '@/components/DateTime'

import levels from '../levels'

export default {
  data() {
    return {
      columns: [
        {
          field: ' ',
          title: ' ',
          key: 'checkbox',
          disallowChangeVisible: true,
          width: 40,
          renderBodyCell: ({ row }, h) => {
            if (row.level !== levels.ERROR) return

            return h('div', {}, [
              h('div', {}, [
                h(UiCheckbox, {
                  nativeOn: {
                    click: () => this.solveLog(row),
                  },
                  attrs: {
                    id: `checkbox-${row.id}`,
                    value: !!row.solved,
                    disabled: true
                  },
                }),
              ]),
            ])
          },
        },
        {
          field: 'date',
          title: 'Дата',
          align: 'left',
          key: 'date',
          width: 120,
          renderBodyCell: ({ row }, h) => {
            return (
              <UiLink class="table-body-cell-nowrap" to={{ name: 'log', params: { id: row.id } }}>
                <DateTime date={row.time} />
              </UiLink>
            )
          },
        },
        {
          field: 'message',
          title: 'Сообщение',
          align: 'left',
          key: 'message',
          width: 120,
          renderBodyCell: ({ row }) => {
            return <div style="min-width: 230px">{getValue(row, 'message')}</div>
          },
        },
        {
          field: 'url',
          title: 'Url',
          align: 'left',
          key: 'url',
          renderBodyCell: ({ row }) => {
            return <div style="min-width: 200px">{getValue(row, 'url')}</div>
          },
        },
        {
          field: 'application',
          title: 'App',
          align: 'left',
          key: 'app',
          renderBodyCell: ({ row }) => {
            if (!(row.application && row.application.domain)) return '—'

            return `${row.application.domain} (${row.application.id})`
          },
        },
        {
          field: 'userId',
          title: 'User',
          align: 'left',
          key: 'user',
          renderBodyCell: ({ row }) => getValue(row, 'userId'),
        },
        {
          field: 'guestId',
          title: 'Guest',
          align: 'left',
          key: 'guest',
          renderBodyCell: ({ row }) => getValue(row, 'guestId'),
        },
      ],
    }
  },
}
